import { AccessRightFilterCollectionModel, ILightWeightUser } from '@fi-shared/models';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { FiDateTimeFormatOptions } from '@fi-shared/utils/format-date';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

export class ForumModel {
    Id: number;
    CreatedByUserId: number;
    CreatedByUserName: string;
    CreatedOn: Date;
    ChangedByUserId: number;
    ChangedByUserName: string;
    ChangedOn: Date;
    CommentsCount: number;
    Name: string;
    Description: string;
    HasEditAccess: boolean;
    LatestActivity: Date | string;
    LatestActivityUserProfile: ILightWeightUser;
    LatestActivityText: string;
    LatestActivityForumPostId: number;
    IsFavorite: boolean;
    LatestActivityDate: string;
    Names: any[];
    Descriptions: any[];
    AccessRightFilterCollection: AccessRightFilterCollectionModel;
    NewForumPostsCount: number;
    ShowInApp: boolean = true;
    PostsCount: number;

    constructor(data?, injector?) {
        if (!data) data = {};

        this.init(data, injector.get(ContentLanguagesService), injector.get(FiFormatDateService));
    }

    init(data, contentLanguagesService: ContentLanguagesService, formatDateService: FiFormatDateService) {
        this.Id = undefined;
        this.CreatedByUserId = undefined;
        this.CreatedByUserName = undefined;
        this.CreatedOn = undefined;
        this.ChangedByUserId = undefined;
        this.ChangedByUserName = undefined;
        this.ChangedOn = undefined;
        this.Name = undefined;
        this.Description = undefined;
        this.HasEditAccess = undefined;
        this.LatestActivity = undefined;
        this.LatestActivityUserProfile = undefined;
        this.IsFavorite = undefined;

        Object.assign(this, data);
        this.LatestActivityDate = this.LatestActivity
            ? formatDateService.formatDate(this.LatestActivity, FiDateTimeFormatOptions)
            : null;

        this.Names = [];
        contentLanguagesService.InitializeContentLanguagesArray(this.Names, data.Names || []);

        this.Descriptions = [];
        contentLanguagesService.InitializeContentLanguagesArray(this.Descriptions, data.Descriptions || []);

        this.AccessRightFilterCollection = new AccessRightFilterCollectionModel();
        //this.AccessRightFilterCollection.SelectionMode = AccessRightTabs.ManualChoice;
        if (data.AccessRightFilterCollection)
            this.AccessRightFilterCollection.InitializeAccessRightFilterCollection(data.AccessRightFilterCollection);
    }
}
